const options = {
  5: "bg-purple-300/5",
  10: "bg-purple-300/10",
  25: "bg-purple-300/25",
  50: "bg-purple-300/50",
  75: "bg-purple-300/75",
  90: "bg-purple-300/90",
  100: "bg-purple-300",
};

const from = {
  5: "from-purple-300/5",
  10: "from-purple-300/10",
  25: "from-purple-300/25",
  50: "from-purple-300/50",
  75: "from-purple-300/75",
  90: "from-purple-300/90",
  100: "from-purple-300",
};

export default function getBackgroundPurple300(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
